import { useUser } from "contexts";
import { SubscriptionStatus } from "data/enums";
import { subscriptionConverter } from "db/converters";
import { getDocument } from "db/queries";
import { useEffect, useState } from "react";
import { COLLECTION_NAME } from ".";

export const useFetchSubscription = () => {
  const [subscription, setSubscription] = useState(null);
  const [error, setError] = useState(null);
  const { loading, profile } = useUser();

  useEffect(() => {
    const fetchSubscription = async () => {
      if (!profile.subscriptionId) return;

      getDocument(
        COLLECTION_NAME,
        profile.subscriptionId,
        subscriptionConverter
      )
        .then((data) => setSubscription(data))
        .catch((error) => setError(error));
    };

    fetchSubscription();
  }, [profile.subscriptionId]);

  return {
    ...subscription,
    availableCredits: profile.credits || 0,
    extraCredits: profile.extraCredits || 0,
    hasCredits: !loading && profile.credits > 0,
    hasSubscription: !loading && !!profile.subscriptionId,
    isPremium:
      !!profile.subscriptionId &&
      subscription?.status === SubscriptionStatus.AUTHORIZED,
    loading: loading || (profile.subscriptionId && !subscription),
    error,
  };
};
